/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The JobCreateResponse model module.
 * @module model/JobCreateResponse
 * @version V1
 */
class JobCreateResponse {
    /**
     * Constructs a new <code>JobCreateResponse</code>.
     * @alias module:model/JobCreateResponse
     */
    constructor() { 
        
        JobCreateResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>JobCreateResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/JobCreateResponse} obj Optional instance to populate.
     * @return {module:model/JobCreateResponse} The populated <code>JobCreateResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new JobCreateResponse();

            if (data.hasOwnProperty('jobId')) {
                obj['jobId'] = ApiClient.convertToType(data['jobId'], 'Number');
            }
            if (data.hasOwnProperty('jobNumber')) {
                obj['jobNumber'] = ApiClient.convertToType(data['jobNumber'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>JobCreateResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>JobCreateResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['jobNumber'] && !(typeof data['jobNumber'] === 'string' || data['jobNumber'] instanceof String)) {
            throw new Error("Expected the field `jobNumber` to be a primitive type in the JSON string but got " + data['jobNumber']);
        }

        return true;
    }


}



/**
 * @member {Number} jobId
 */
JobCreateResponse.prototype['jobId'] = undefined;

/**
 * @member {String} jobNumber
 */
JobCreateResponse.prototype['jobNumber'] = undefined;






export default JobCreateResponse;

